const errTranslations: {
  [lang: string]: { [message: string]: string };
} = {
  en: {
    'This email already exists. Please sign in instead.':
      'This email is already registered. Please sign in.',
    'Incorrect email or password.': 'Invalid email or password.',
    'Please verify your email before signing in.':
      'Verify your email before logging in.',
    'Welcome to JF Club': 'Welcome to JF Club',
    'Exclusive video performances': 'Exclusive video performances',
    "Behind-the-scenes insights into Julia's life and music":
      "Behind-the-scenes insights into Julia's life and music",
    'Live Q&A with Julia': 'Live Q&A with Julia',
    'Early Access to Concerts and Special Events':
      'Early Access to Concerts and Special Events',
    'Private Community of Music Lovers': 'Private Community of Music Lovers',
  },
  fr: {
    'This email already exists. Please sign in instead.':
      'Cet e-mail est déjà enregistré. Veuillez vous connecter.',
    'Incorrect email or password.': 'E-mail ou mot de passe invalide.',
    'Please verify your email before signing in.':
      'Veuillez vérifier votre e-mail avant de vous connecter.',
    'Welcome to JF Club': 'Bienvenue au Club JF',
    'Exclusive video performances': 'Performances vidéo exclusives',
    "Behind-the-scenes insights into Julia's life and music":
      'Coulisses de la vie et de la musique de Julia',
    'Live Q&A with Julia': 'Séance de questions-réponses en direct avec Julia',
    'Early Access to Concerts and Special Events':
      'Accès anticipé aux concerts et événements spéciaux',
    'Private Community of Music Lovers':
      'Communauté privée de passionnés de musique',
  },
  de: {
    'This email already exists. Please sign in instead.':
      'Diese E-Mail-Adresse existiert bereits. Bitte melden Sie sich stattdessen an.',
    'Incorrect email or password.': 'Falsche E-Mail-Adresse oder Passwort',
    'Please verify your email before signing in.':
      'Bitte verifizieren Sie Ihre E-Mail, bevor Sie sich anmelden.',
    'Welcome to JF Club': 'Willkommen beim JF Club',
    'Exclusive video performances': 'Exklusive Videoauftritte',
    "Behind-the-scenes insights into Julia's life and music":
      'Hinter den Kulissen von Julias Leben und Musik',
    'Live Q&A with Julia': 'Live Q&A mit Julia',
    'Early Access to Concerts and Special Events':
      'Früher Zugang zu Konzerten und Sonderveranstaltungen',
    'Private Community of Music Lovers':
      'Private Gemeinschaft von Musikliebhabern',
  },
  es: {
    'This email already exists. Please sign in instead.':
      'Ya existe una cuenta asociada a este correo electrónico. Por favor, inicia sesión',
    'Incorrect email or password.':
      'Correo electrónico o contraseña incorrectos.',
    'Please verify your email before signing in.':
      'Por favor, verifica tu correo electrónico antes de iniciar sesión',
    'Welcome to JF Club': 'Bienvenido al Club JF',
    'Exclusive video performances': 'Actuaciones exclusivas en vídeo',
    "Behind-the-scenes insights into Julia's life and music":
      'Detrás de cámaras de la vida y la música de Julia',
    'Live Q&A with Julia': 'Preguntas y respuestas en vivo con Julia',
    'Early Access to Concerts and Special Events':
      'Acceso anticipado a conciertos y eventos especiales',
    'Private Community of Music Lovers':
      'Comunidad privada de amantes de la música',
  },
  vlca: {
    'This email already exists. Please sign in instead.':
      'Ja existix un compte associat a este correu electrònic. Per favor, inicia sessió',
    'Incorrect email or password.':
      'Correu electrònic o contrasenya incorrectes',
    'Please verify your email before signing in.':
      "Si us plau, verifica el teu correu electrònic abans d'iniciar sessió.",
    'Welcome to JF Club': 'Benvinguts al JF Club',
    'Exclusive video performances': 'Performances Exclusives en Vídeo',
    "Behind-the-scenes insights into Julia's life and music":
      'Darrere de les càmeres de la vida i la música de Julia',
    'Live Q&A with Julia': 'Preguntes i respostes en directe amb Julia',
    'Early Access to Concerts and Special Events':
      'Accés anticipat als concerts i esdeveniments especials',
    'Private Community of Music Lovers':
      "Comunitat privada d'amants de la música",
  },
};
export const getTranslation = (message: string, lang = 'en') => {
  return (
    errTranslations[lang][message] || errTranslations['en'][message] || message
  );
};
